import {
  Autocomplete,
  CircularProgress,
  TextField,
  TextFieldProps,
} from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { DisplayMode } from "services/KnowfullyAdminClient";

type SelectDisplayModeProps = {
  value?: number;
  onChange: (id: number | undefined) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  textFieldProps?: Partial<TextFieldProps>;
};

const SelectDisplayMode = ({
  value,
  onChange,
  label,
  disabled,
  required,
  error,
  textFieldProps,
}: SelectDisplayModeProps) => {
  const { formatMessage: t } = useIntl();
  const { notificationsConfigurationsService } = useGlobalContext();

  const { data, isLoading } = useQuery(
    ["notificationsConfigurationsService.getDisplayModes"],
    () => notificationsConfigurationsService.getDisplayModes(),
  );

  const options = (data?.data ?? []) as DisplayMode[];
  const selectedOption = options.find((o) => o.id === value) ?? null;

  return (
    <Autocomplete<DisplayMode>
      value={selectedOption}
      onChange={(_event, newValue) => onChange(newValue?.id)}
      options={options}
      loading={isLoading}
      disabled={disabled || isLoading}
      getOptionLabel={(option) => option.name || ""}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          variant="standard"
          label={label || t({ id: "displayMode" })}
          required={required}
          error={error}
          InputProps={{
            ...params.InputProps,
            startAdornment: isLoading && <CircularProgress size={16} />,
          }}
        />
      )}
    />
  );
};

export default SelectDisplayMode;
